import create from 'zustand'
import analyticsMiddleware from '../middleware/analyticsMiddleware'

const useUiStore = create(
  analyticsMiddleware(set => ({
    // current view of the data
    view: 'map',
    isEmbed: false,
    embedSecondary: false,
    setView: view => set({ view }),
    // when forceVars is set, the provided varnames are used for the tooltip
    forceVars: null,
    // currently hovered id
    hovered: null,
    setHovered: (
      hoveredId,
      coords,
      options = {
        showTooltip: true,
        showMarkers: true,
        forceVars: null
      }
    ) =>
      hoveredId
        ? set(state => ({
            hovered: hoveredId,
            coords: coords ? coords : state.coords,
            showTooltip: options.showTooltip,
            showMarkers: options.showMarkers,
            forceVars: options.forceVars
          }))
        : set({
            showTooltip: false,
            showMarkers: false,
            forceVars: null
          }),
    // x, y coords of tooltip
    coords: [0, 0],
    setCoords: coords => set({ coords }),
    // boolean determining tooltip visibility
    showTooltip: false,
    setShowTooltip: showTooltip => set({ showTooltip }),
    // boolean determining if markers should be shown for hovered items
    showMarkers: false,
    setShowMarkers: showMarkers => set({ showMarkers }),
    // boolean determining if menu is open
    showMenu: false,
    toggleMenu: () =>
      set(state => ({ showMenu: !state.showMenu })),
    // boolean determining if link dialog is open
    showLinkDialog: false,
    toggleLinkDialog: () =>
      set(state => ({ showLinkDialog: !state.showLinkDialog })),
    // boolean determining if link dialog is open
    showEmbedDialog: false,
    toggleEmbedDialog: () =>
      set(state => ({
        showEmbedDialog: !state.showEmbedDialog
      })),
    // boolean determining if help is open
    showHelp: false,
    toggleHelp: () =>
      set(state => ({ showHelp: !state.showHelp })),
    // boolean determining is preview chart is visible
    showChart: true,
    setShowChart: showChart => set({ showChart }),
    toggleChart: () =>
      set(state => ({ showChart: !state.showChart })),
    // boolean determining if controls are condensed
    panelCondensed: true,
    togglePanelCondensed: () =>
      set(state => ({ panelCondensed: !state.panelCondensed })),
    // boolean determining if controls are hovered open
    panelHovered: false,
    setPanelHovered: panelHovered => set({ panelHovered }),
    togglePanelHovered: () =>
      set(state => ({ panelHovered: !state.panelHovered })),
    // string determining which selection is currently active
    selection: null,
    setSelection: selection => {
      set({ selection })
    },
    // string to determine which filter selection is active
    filterPanel: null,
    setFilterPanel: filterPanel => set({ filterPanel }),
    setViewFromRoute: params => {
      set({
        view: params.view,
        isEmbed: !!params.embed,
        embedSecondary: params.secondary.split('+').length > 1
      })
    },
    // boolean to determine if loading curtain is showing
    showCurtain: true,
    setShowCurtain: showCurtain => set({ showCurtain }),
    // boolean to determine if loading curtain filter buttons is showing
    showCurtainFilters: false,
    setShowCurtainFilters: showCurtainFilters => set({ showCurtainFilters }),
    // boolean to determine loading curtain should be skipped on next visit
    skipCurtain: false,
    setSkipCurtain: skipCurtain => set({ skipCurtain }),
    // object of hint locations with boolean
    showPanelHints: {},
    setShowPanelHint: (type, value) => set(store  => ({
			showPanelHints: {
				...store.showPanelHints,
				[type]: value
			}
		})),
  }))
)

export default useUiStore
